import React, { useCallback, useState } from 'react';
import { Table, Space, Button, Popconfirm, Spin } from 'antd';
import { 
  TableWrapper } from 'components/molecules';
import { ColumnsType } from 'antd/lib/table/interface';
import { TotalNumMenu } from 'components/atoms';
import { useTableInfo } from 'hooks';
import { INIT_PAGESIZE } from 'commons/constants';

interface FormItemProps {
  historyList: StudentHistoryListDto[] | undefined;  
  searchResult: any;  
  onChangePageInfo : (pageNo: number, pageSize: number) => void;
}

const STUDENTHistoryTable = ({historyList, searchResult, onChangePageInfo}: FormItemProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const [isLoding, setIsLoading] = useState<boolean>(false); 
  const columns: ColumnsType<StudentHistoryListDto> = [
    {
      title: '구분',
      dataIndex: 'group_name',
      key: 'group_name',
      width: '100px',
      align: 'center',
      ellipsis: true,
    },     
    {
      title: '과정',
      dataIndex: 'lecture_name',
      key: 'lecture_name',
      width: 'auto',
      align: 'center',
      ellipsis: true,
      render: (_value, record) => {
        return (
          <label>[{record.b2c_group_srl}]{_value}</label>
        )
      }       
    }, 
    {
      title: '교육일',
      key: 'lecture_date',
      width: '180px',
      align: 'center',   
      render: (record) => {
        return (
          <label>{record.start_date} ~ {record.end_date}</label>
        )
      }           
    },       
    {
      title: '회사',
      dataIndex: 'company_name',
      key: 'company_name',
      width: '100px',
      align: 'center',
      ellipsis: true,
    },
    {
      title: '이메일',
      dataIndex: 'email',
      key: 'email',
      width: 'auto',
      align: 'left',
      ellipsis: true,
    },  
    {
      title: '취소',
      dataIndex: 'delete_yn',
      key: 'delete_yn',
      width: '60px',
      align: 'center',
      ellipsis: true,
    }, 
    {
      title: '연기',
      dataIndex: 'putoff_yn',
      key: 'putoff_yn',
      width: '60px',
      align: 'center',
      ellipsis: true,
    },         
  ];

  /* ======================================================
  * events
  * ====================================================== */ 
 
  /* ======================================================
  * hooks
  * ====================================================== */
  const { pagination, onTableChange } = useTableInfo({
    pageInfo: {
      pageNo: Number(searchResult.pageNo) || 1,
      pageSize: Number(searchResult.pageSize) || INIT_PAGESIZE,
    },
    datas: historyList,
    totalCount: searchResult.totalCount,
    onChangePageInfo,
  });

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Spin spinning={isLoding} tip="처리중입니다. 잠시만 기다려 주세요." size="large">
        <TotalNumMenu totalNum={searchResult.totalCount}/>
        <TableWrapper isSearch={!!searchResult.searchValue}>
          <Table
            tableLayout="fixed"
            dataSource={historyList}
            columns={columns}
            pagination={pagination}
            onChange={onTableChange}
            style={{ width: '100%', overflowX: 'auto', minWidth: 600 }}
            className="columnCenterFixTable clickable"
            showSorterTooltip={false}
            rowKey={'id'}
          />
        </TableWrapper>  
      </Spin>
    </Space>
  );
};

export default STUDENTHistoryTable;
